import Vue from "vue";
import axios from "axios";
import Store from "@/store/store.js";
import * as Alert from "@/utils/AlertUtil";

const API = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
});

const MULTIPART = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
  },
});

API.interceptors.request.use(config => {
  // @TODO localStorageをvue.storeから呼べる方法が見つかったら差し替える、なければここのまま
  Vue.$log.info(config.url);
  Vue.$log.info(Store.state.auth);
  if (config.headers) {
    //config.headers["id_token"] = Store.state.session.session.id_token;
    config.headers["id_token"] = Store.state.auth.idToken;
    Vue.$log.info("id_token", config.headers["id_token"]);
  }

  return config;
});

var count401 = 0;

API.interceptors.response.use(
  response => {
    Vue.$log.info("API Response = ", response);

    return Promise.resolve(response);
  },
  error => {
    const status = error.response ? error.response.status : null;

    Vue.$log.error(status);

    if (count401 >= 1) {
      Alert.fire("Error", "再ログインしてください。").then(_ => {
        if (Store.state.session.session.is_project) {
          location.href = "/login/project";
        } else if (Store.state.session.session.is_enterprise) {
          location.href = "/login/enterprise";
        } else if (Store.state.session.session.is_personal) {
          location.href = "/login/personal";
        }
      });
      count401 = 0;

      return false;
    }
    if (status == 400) {
      return Alert.fire("Error", error.response.data.message).then(_ =>
        Promise.reject(error.response)
      );
    } else if (status == 404) {
      return Alert.fire("Error", error.response.data.message);
    }
    // Validation error
    else if (status == 422) {
      return Promise.reject(error.response.data.validation_results);
    } else if (status == 401) {
      return Promise.resolve(status);
      // ログイン画面の場合
      // if (error.config.url.indexOf("admin/login") >= 0) {
      //   return Alert.fire("エラー。", "ログイン情報が不正です。").then(() => Store.dispatch("session/reLogin").then(token => {
      //     error.config.headers["id_token"] = token;
      //     error.config.baseURL = undefined;
      //
      //     return default.request(error.config);
      //   }));
      // } else {
      //   count401++;
      //   return Store.dispatch("session/reLogin").then(token => {
      //     error.config.headers["id_token"] = token;
      //     error.config.baseURL = undefined;
      //
      //     return default.request(error.config);
      //   });
      // }
    } else {
      return Alert.fire("Error", "ネットワークエラー");
    }
  }
);

MULTIPART.interceptors.request.use(config => {
  config.headers["id_token"] = Store.state.auth.idToken;
  Vue.$log.info("id_token", config.headers["id_token"]);
  return config;
});

MULTIPART.interceptors.response.use(
  response => {
    Vue.$log.info("API Response = ", response);

    return Promise.resolve(response);
  },
  function(error) {
    Vue.$log.error(error);

    if (!error.response) {
      return Alert.fire("Error", "ネットワークエラー");
    } else if (error.response.status === 404) {
      return Promise.resolve();
    } else if (error.response.status === 401) {
      Store.dispatch("session/reLogin", {
        key: new Date().getTime(),
        message: error.response.data,
        status: "danger",
      }).catch(error => {
        Promise.reject(error);
      });
    } else if (error.response.status !== 400) {
      return Alert.fire("Error", error.response.data.message);
    } else if (error.response.status === 400) {
      return Alert.fire("Error", error.response.data.message);
    }
    return Promise.reject(error.response);
  }
);

export { API, MULTIPART };
